import styled from "styled-components";
export const UploadPaySlipContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px;
  width: 100%;
  margin-bottom: 32px;
  
    h1{
      font-size: 19px;
      font-weight: 700;
      line-height: 23px;
      letter-spacing: 0.4px;
      text-align: left;
      color: ${({theme}) => theme.black};
    }
    h3{
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      letter-spacing: 0.3px;
      color: ${({theme}) => theme.grayLight};
    }
  
  .upload_area{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /*@media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-direction: column;
    .label{
      width: 100%;
    }
    .action {
      width: 100%;
      button {
        width: 100%;
        margin-top: 10px;
      }
    }
  }*/
`

export const PreviewDocument = styled.div`
  padding: 10px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.grayBackground};

  button {
    all: unset;
    cursor: pointer;
    color: ${({theme}) => theme.accent};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  svg {
    margin-left: 8px;

    :hover {
      cursor: pointer;
    }
  }
}
`

export const UploadInvoice = styled.button`
  all: unset;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  p {
    color: ${({theme}) => theme.gray};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }

  .icon {
    margin-right: 8px;
  }
  
  &:hover{
    p{
      text-decoration: underline;
      color: ${({theme}) => theme.accent};
    }
    .icon {
      svg {
        fill: ${({theme}) => theme.accent};
      }
    }
  }
`
